import styled from 'styled-components';
import { themed, clickableStyle } from '../utils/system';
import Text from '../Text';
var Link = styled(Text)(themed('Link'), clickableStyle);
Link.displayName = 'Link';
Link.defaultProps = {
  as: 'a'
};
export default Link;